module.exports = __webpack_public_path__ + "img/rs.05d3c228.svg";